import ConfirmationModal from "components/layout/confirmation-modal/ConfirmationModal";
import MainLayout from "components/layout/main-layout/MainLayout";
import { titles } from "constants/titles";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
import { finilizeMyCancelRequest, undoMyCancelRequest } from "redux/MedicalAlertUsers/actions";
import { convertInRequiredTimeZone, formatDate, getStatusColor } from "utility";
import './SubscriptionDetail.css'
import CustomButton from "components/widgets/custom-button/CustomButton";

const SubScriptionDetail = () => {
    const [showUndoRequestPopup, setIsShowUndoRequestPopup] = useState(false);
    const [isUndoRequest, setIsUndoRequest] = useState(false);
    const [currentPopUpData, setCurrentPopUpData] = useState(null);
    const [snackBarMessage, setSnackBarMessage] = useState({
        message: "",
        type: "",
    });

    const userData = useSelector((store) => store?.auth?.userData);
    const { cancelSubscriptionList, loading, selectedMedicalUser } = useSelector((store) => store?.medicalAlertUsers);
    const { currentTimeZone } = useSelector((store) => store?.common);

    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    const medicalUserData = location?.state?.medicalUserData;
    const requestData = location?.state?.requestData;

    const onUndoRequest = () => {
        setIsUndoRequest(true);
        setIsShowUndoRequestPopup(true);
    };

    const onFinilizeRequest = () => {
        setIsUndoRequest(false);
        setIsShowUndoRequestPopup(true);
    };

    const onClose = () => {
        setIsUndoRequest(false);
        setIsShowUndoRequestPopup(false);
    };

    const handleOnConfirmYes = () => {
        const params = {
            dispatch,
            payload: {
                medical_alert_user_id: medicalUserData?.medical_alert_user_id,
                request_id: requestData?.request_id,
            },
            userType: userData?.isGuestUser ? "guestuser" : "accountowner",
            history,
            successCallBack: () => history?.goBack(),
            setSnackBarMessage
        };
        if (isUndoRequest) {
            undoMyCancelRequest(params);
        } else {
            finilizeMyCancelRequest(params);
        }
        setIsShowUndoRequestPopup(false);
    };

    const convertInLocalTimeZone = (date) => {
        return convertInRequiredTimeZone(
            date,
            selectedMedicalUser?.timezone,
            currentTimeZone
        );
    };


    const renderStatusBadge = (status) => {
        let label = null;

        switch (status) {
            case "cancelled":
                label = titles?.withdrawn;
                break;
            case "draft":
                label = titles?.action_required;
                break;
            case "waiting_for_doc":
                label = titles?.under_review;
                break;
            case "denied":
                label = titles?.denied;
                break;
            case "pending_cancel":
                label = titles?.scheduledToCancel;
                break;
            case "completed":
                label = titles?.completed;
                break;
            default:
                return null;
        }

        const badgeColor = getStatusColor(status);

        return (
            <div className="sbd_action-required-button" style={{ backgroundColor: badgeColor }}>
                <span className="sbd_action-required-button-title-style">{label}</span>
            </div>
        );
    };

    const renderKeyLabelsAndValues = (titleToDisplay, primaryClass, secondaryClass) => (
        <p className={`sbd_${primaryClass} sbd_${secondaryClass}`}>{titleToDisplay}</p>
    );

    const renderCustomFields = (title, desc) => (
        <div className="sbd_view-width">
            <p className="sbd_label-style">{title}</p>
            <p className="sbd_desc-text">{desc}</p>
        </div>
    );


    return (
        <MainLayout
            text={titles?.serviceRequestDetail}
            isBackHide={false}
            isSemiHeader={true}
            white={true}
            snackBarMessage={snackBarMessage}>

            <ConfirmationModal
                show={showUndoRequestPopup}
                title={" "}
                description={
                    isUndoRequest
                        ? titles?.undo_my_cancel_message
                        : titles?.finalise_cancel_message
                }
                btnText={titles?.yes}
                onClose={onClose}
                onClick={() => handleOnConfirmYes()}
            />


            {renderKeyLabelsAndValues(
                `${titles?.request_id}: ${requestData?.request_number}`,
                "services-request-title"
            )}

            {renderCustomFields(titles?.account, requestData?.account_no)}
            {renderCustomFields(titles?.subscriber, requestData?.subscriber_name)}
            {renderCustomFields(titles?.cancel_reason, requestData?.cancel_reason || "N/A")}
            {renderCustomFields(titles?.auxilary_email, requestData?.auxiliary_email || "N/A")}
            {renderCustomFields(titles?.contact_number, requestData?.contact_no || "N/A")}
            {renderCustomFields(titles?.request_date, convertInLocalTimeZone(requestData?.date_requested))}
            {renderCustomFields(titles?.service_end_data, formatDate(requestData?.scheduled_cancel_date))}

            <div className="sbd_view-width">
                <p className="sbd_label-style">{titles?.status}</p>
                <div className="sbd_button-container">
                    {renderStatusBadge(requestData?.status)}
                </div>
            </div>

            <div className="sbd_view-container">
                {(requestData?.status === "pending_cancel" ||
                    requestData?.status === "draft" ||
                    requestData?.status === "waiting_for_document_approval") && (
                        <CustomButton
                            width={"100%"}
                            className={"undo-button undo-button-title"}
                            text={titles?.undo_my_cancel}
                            onClick={() => onUndoRequest()}
                        />
                    )}

                {(requestData?.status === "draft" ||
                    requestData?.status === "waiting_for_document_approval") && (
                        <CustomButton
                            width={"100%"}
                            className={"undo-button finalise-button fialise-button-title"}
                            text={titles?.finalise_cancelation}
                            onClick={() => onFinilizeRequest()}
                        />
                    )}
            </div>


        </MainLayout>
    )
}

export default SubScriptionDetail;